import {Action} from "redux";
import {ArticleTemplateId} from "./data";
import {ArticleTemplateFromPHP, Column} from "../data";

export type ListAction = SelectAllArticleTemplates
	| UnselectAllArticleTemplates
	| SelectArticleTemplate
	| UnselectArticleTemplate
	| ChangeColumn
	| ChangePriority
	| AddCopiedArticles
	| DeleteArticles

type SelectAllArticleTemplates = {
	type: 'select all article templates'
}

type UnselectAllArticleTemplates = {
	type: 'unselect all article templates'
}

type SelectArticleTemplate = {
	type: 'select article template'
	id: string
}

type UnselectArticleTemplate = {
	type: 'unselect article template'
	id: string
}

type ChangeColumn = {
	type: 'change column'
	id: string
	column: Column
}

type ChangePriority = {
	type: 'change priority'
	id: string
	priority: number
}

type AddCopiedArticles = {
	type: 'add copied article templates'
	copiedArticleTemplates: ArticleTemplateFromPHP[]
}

type DeleteArticles = {
	type: 'delete article templates'
	deletedArticleTemplateIds: ArticleTemplateId[]
}

export type ListActionWrapper = {
	type: 'list action'
	action: ListAction
}

export const isListAction = (a: Action): a is ListActionWrapper => a.type == 'list action'



// WEBPACK FOOTER //
// ./src/communications/article-templates/writable/actions.ts